
import React, { useContext, useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import styled from "styled-components";
import { AppContext } from "../../../contexts/AppContext";


const DataSidebarWrapper = styled.div`
  width: 250px;
  background-color: var(--sidebar-bg);
  border: 1px solid var(--sidebar-border-color);
  box-sizing: content-box;
  margin-left: -20px;
  margin-top: -40px;

  height: 100vh;
  position:sticky;
`;

const DataSidebarInnerWrapper = styled.div`
  width: 250px;
  overflow: hidden auto;
  height: 100vh;
  padding: 20px 16px 8px 16px;
  display: flex;
  flex-direction: column;
  position: fixed;
`;

const DataSidebarItems = styled.div`
  margin-top: 20px;
`;

const DataSidebarItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
  padding: 13px 5px 13px 10px;
  border-radius: 8px;
  cursor: pointer;

  &.active {
    background-color: var(--sidebar-active-item-bg);
  }

  &.active  * {
    color: var(--sidebar-active-item-color) !important;
  }

  &:hover:not(.active) {
    background-color: var(--sidebar-active-item-bg);
  }
`;

const DataSidebarItemText = styled.span`
  font-size: 16px;
  font-weight: 300;
  color: var(--sidebar-item-color);
  padding-left: 10px;
`;

const DataSidebarItemIcon = styled(Icon)`
  font-size: 18px;
  color: var(--sidebar-item-color);
`;

export const DataSidebar = ({
  show = true,
  defaultSelectedTab = window.location.hash ? window.location.hash.substr(1) : "details",
  onNavItemClicked = () => { },
  onToggle = () => { },
}) => {
  console.log("!!! DEFAULT SELECTED TAB: ", defaultSelectedTab)
  const [selectedTab, setSelectedTab] = useState(defaultSelectedTab);
  const { selectedClient } = useContext(
    AppContext
  );
  console.log("!!! SIDEBAR SELECTED CLIENT: ", selectedClient)

  useEffect(() => {
    setSelectedTab(defaultSelectedTab);
  }, [defaultSelectedTab]);

  useEffect(() => {
    window.history.pushState(null, null, `#${selectedTab}`);
    onNavItemClicked(selectedTab);

    // eslint-disable-next-line
  }, [selectedTab]);

  const selectTab = (tab) => {
    setSelectedTab(tab);
    // Update to use the has of the tab
  };

  const isSelected = (tab) => {
    console.log("!!! CHECKING IF SELECTED: ", tab, selectedTab, selectedTab === tab);
    return selectedTab === tab ? "active" : "";
  }


  return (
    <DataSidebarWrapper
      style={{
        width: show ? "250px" : "24px",
        transition: "width 0.3s ease-in-out",
        height: "100vh",
        marginTop: "-20px",
      }}

    >
      <button
        onClick={() => {
          onToggle();
        }}
        style={{
          width: "24px",
          height: "40px",
          backgroundColor: "var(--sidebar-active-item-bg)",
          color: "var(--sidebar-active-item-color)",
          borderTopRightRadius: ".25rem",
          borderBottomRightRadius: ".25rem",
          outline: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          top: "50%",
          right: "-24px",
          zIndex: 1,
          border: "none",
          cursor: "pointer",
          fontSize: "20px",
        }}
      >
        <i className="fas fa-ellipsis-v"></i>
      </button>
      <DataSidebarInnerWrapper
        style={{ display: show ? "flex" : "none" }}
      >
        <DataSidebarItems style={{ flexGrow: 0 }}>
          <DataSidebarItem className={isSelected("data-items")} onClick={() => selectTab("data-items")}>
            <span>
              <DataSidebarItemIcon icon="lucide:info" />
            </span>
            <DataSidebarItemText>Data Items</DataSidebarItemText>
          </DataSidebarItem>
          <DataSidebarItem className={isSelected("data-sets")} onClick={() => selectTab("data-sets")}>
            <span>
              <DataSidebarItemIcon icon="lucide:files" />
            </span>
            <DataSidebarItemText>Data Sets</DataSidebarItemText>
          </DataSidebarItem>
        </DataSidebarItems>
      </DataSidebarInnerWrapper>
    </DataSidebarWrapper>
  );
};

export default DataSidebar;

